import React from 'react';
import { observer } from 'mobx-react-lite';
import { BaseContainer } from '@components/BaseContainer';
import PollResultsBg from '@app/assets/pollsPageBg.png';
import NokiaLogo from '@app/assets/nokiaLogoHeader';
import { Container } from './styles';
import { useParams } from 'react-router-dom';
import Poll from '@components/SinglePoll/Poll';

const SinglePollPage = () => {
  const { pollId } = useParams<{
    pollId: string;
  }>();

  return (
    <BaseContainer min bgImage={PollResultsBg}>
      <Container>
        <NokiaLogo fill="#fff" />
        <Poll pollSlug={pollId} />
      </Container>
    </BaseContainer>
  );
};

export default observer(SinglePollPage);
